import { SagaIterator } from "redux-saga";
import { takeLatest, put, call, select } from "redux-saga/effects";
import { union } from "ts-action";
import * as actions from "../../actions";
import { getLoyaltyGiftMenuApi } from "../../../axios";
import { selectToken } from "../../selectors";
import { getLoyaltyGiftMenuAction } from "../../../constants";
import { IRootReducerState } from "../../rootReducer";
import { GiftGroup, GiftItem } from "../../../types";
import { getShownGiftItemIdsByPosId } from "../../../helpers/gift-list";

const actionTypes = union({
  getLoyaltyGiftMenu: actions.getLoyaltyGiftMenu,
});

function* getLoyaltyGiftMenuSaga({
  payload: pos_entity_id,
}: typeof actionTypes): SagaIterator {
  try {
    const giftGroupsByPosId = yield select(
      (state: IRootReducerState) =>
        state.multiPosGiftGroupsReducer.giftGroupsByPosId
    );
    const token = yield select(selectToken);
    const response = yield call(getLoyaltyGiftMenuApi, token, pos_entity_id);

    if (!pos_entity_id) {
      yield put(
        actions.getLoyaltyGiftMenuSuccess({
          menu: response.data,
          excludedGiftItemIds: [],
        })
      );
      return;
    }

    const excludedGiftItemIds = getShownGiftItemIdsByPosId(
      giftGroupsByPosId,
      pos_entity_id
    );

    const posGiftGroups = giftGroupsByPosId[pos_entity_id];
    let existingGiftItems: GiftItem[] = [];

    if (posGiftGroups?.giftGroupsById) {
      const excludedItemsSet = new Set(excludedGiftItemIds);

      existingGiftItems = Object.values(posGiftGroups.giftGroupsById)
        .flatMap((group) => {
          const typedGroup = group as GiftGroup;
          return typedGroup?.items || [];
        })
        .filter(
          (item): item is GiftItem =>
            Boolean(item) &&
            typeof item === "object" &&
            "id" in item &&
            "name" in item &&
            !excludedItemsSet.has(item.id)
        );
    }
    const updatedMenu =
      existingGiftItems.length > 0
        ? response.data.map((category) => {
            const index = existingGiftItems.findIndex(
              (item) => item.category_id === category.id
            );
            if (index === -1) return category;
            return {
              ...category,
              items: [...category.items, ...existingGiftItems.slice(index)],
            };
          })
        : response.data;
    yield put(
      actions.getLoyaltyGiftMenuSuccess({
        menu: updatedMenu,
        excludedGiftItemIds,
      })
    );
  } catch (e) {
    yield put(actions.getLoyaltyGiftMenuFailure(e as Error));
  }
}

export function* watchGetLoyaltyGiftMenuSaga(): SagaIterator {
  yield takeLatest(getLoyaltyGiftMenuAction.requested, getLoyaltyGiftMenuSaga);
}
